import React from "react";

export const ChevronLeftDisabled = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" {...props}>
            <circle cx="19" cy="18.9998" r="19" fill="#32393E" fillOpacity="0.1"/>
            <path d="M21 12.9998L15 18.4998L21 23.9998" stroke="#32393E"/>
        </svg>
    )
}
